import loadable from '@wix/yoshi-flow-editor/loadable';
import {RichContentViewerProps} from './RichContentViewer';

export const LazyRichContentViewer = loadable<RichContentViewerProps>(
  () => import(/* webpackChunkName: "LazyRichContentViewer" */ './RichContentViewer'),
  {
    resolveComponent: (components) => components.RichContentViewer,
  }
);
